import React from 'react';
import './HoneymoonVideoSection.css';
import vdo from "../../../Images/trip_vdo.mp4"

const HoneymoonVideoSection = () => {
  return (
    <section className="hmv-section">
      <div className="hmv-container">
        {/* Left: Text Content */}
        <div className="hmv-text-content">
          <span className="hmv-badge">✦ The Temple’s Tale </span>
          <h2 className="hmv-title">
            Your Dream Wedding <br /> Starts Here
          </h2>
          <p className="hmv-description">
           Trijuginarayan is a sacred temple in Uttarakhand, revered as the divine site where Lord Shiva and Goddess Parvati’s celestial wedding took place. Lord Vishnu performed the holy Kanyadaan, while Lord Brahma served as the chief priest, conducting the ceremony with Vedic rituals in the presence of sages and celestial beings. It is said that the sacred fire lit during their marriage still burns eternally in front of the temple, symbolizing the everlasting bond of divine love. Mentioned in the Skanda Purana, Trijuginarayan stands as an eternal testament to purity, devotion, and the timeless union of Shiva and Shakti.
          </p>
        </div>

        {/* Right: Video */}
        <div className="hmv-video-wrapper">
          <video
            className="hmv-video"
            controls
            preload="metadata"
            poster="https://triyuginarayanweddings.com/wp-content/uploads/2025/09/Triyuginarayan-Temple-Planing.webp"
          >
            <source
              src={vdo}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </section>
  );
};

export default HoneymoonVideoSection;